<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :form="form" :rules="rules" class='' :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="pay_type" label="微信支付版本" name="pay_type" v-if='is_have_v3'>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-radio-group v-model:value="form.pay_type">
                <a-radio :value="1">V2版本 </a-radio>
                <a-radio :value="2">V3版本</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
         <a-form-item ref="v3_cert_verify_mode" label="微信证书验证模式" name="v3_cert_verify_mode" v-if='form.pay_type==2'>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-radio-group v-model:value="form.v3_cert_verify_mode">
                <a-radio value="1">微信平台证书 </a-radio>
                <a-radio value="2">微信支付公钥</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
           <a-form-item ref="v3_pub_key_gray" label="支付公钥灰度状态" name="v3_pub_key_gray" v-if='form.pay_type==2'>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-radio-group v-model:value="form.v3_pub_key_gray">
                <a-radio value="1">灰度中 </a-radio>
                <a-radio value="2">已成功</a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="v3_pub_key_id" label="微信公钥ID" name="v3_pub_key_id"  v-if='form.pay_type==2&&form.v3_cert_verify_mode==2'>
            <a-row :gutter="16">
              <a-col :span="20">
                <a-textarea auto-size v-model:value='form.v3_pub_key_id' placeholder='请输入微信公钥ID'  />
              </a-col>
            </a-row>
          </a-form-item>
                 <a-form-item ref="v3_pub_key" label="微信公钥" name="v3_pub_key" v-if='form.pay_type==2&&form.v3_cert_verify_mode==2'>
            <a-row :gutter="16">
              <a-col :span="20">
                <a-textarea auto-size  v-model:value='form.v3_pub_key' placeholder='请输入微信公钥'  />
              </a-col>
            </a-row>
          </a-form-item>
        <!-- v2 -->
        <div v-if='form.pay_type==1'>
          <a-form-item ref="appid" label="AppID" name="appid">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-input v-model:value='form.appid' placeholder='请输入AppID'  />
              </a-col>
              <a-col :span="12">
                <p>（应用ID -- v2）</p>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="app_secret" label="AppSecret" name="app_secret">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-input v-model:value='form.app_secret' placeholder='请输入AppSecret'  type="password"/>
              </a-col>
              <a-col :span="12">
                <p>（应用密钥 -- v2）</p>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="mchid" label="MCHID" name="mchid">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-input v-model:value='form.mchid' placeholder='请输入MCHID'  />
              </a-col>
              <a-col :span="12">
                <p>（商户号，申请微信支付的邮件中获取 -- v2）</p>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="key" label="Key" name="key">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-input v-model:value='form.key'  type="password" placeholder='请输入key'  />
              </a-col>
              <a-col :span="12">
                <p>（32位的API密钥 -- v2）</p>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="ssl_cert" label="ssl_cert" name="ssl_cert">
            <a-row :gutter="16">
              <a-col :span="20">
                <a-textarea auto-size v-model:value='form.ssl_cert' placeholder='请输入ssl_cert'  />
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="ssl_key" label="ssl_key" name="ssl_key">
            <a-row :gutter="16">
              <a-col :span="20">
                <a-textarea auto-size  v-model:value='form.ssl_key' placeholder='请输入ssl_key'  />
              </a-col>
            </a-row>
          </a-form-item>
        </div>
        <!-- v3 -->
        <div v-if='form.pay_type==2'>
          <a-form-item ref="v3_appid" label="AppID" name="v3_appid">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-input v-model:value='form.v3_appid' placeholder='请输入AppID'  />
              </a-col>
              <a-col :span="12">
                <p>（应用ID -- v3）</p>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="v3_app_secret" label="AppSecret" name="v3_app_secret">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-input v-model:value='form.v3_app_secret' type="password" placeholder='请输入AppSecret'  />
              </a-col>
              <a-col :span="12">
                <p>（应用密钥 -- v3）</p>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="v3_mchid" label="MCHID" name="v3_mchid">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-input v-model:value='form.v3_mchid' placeholder='请输入MCHID'  />
              </a-col>
              <a-col :span="12">
                <p>（商户号，申请微信支付的邮件中获取 -- v3）</p>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="v3_key" label="Key" name="v3_key">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-input v-model:value='form.v3_key'  type="password" placeholder='请输入key'  />
              </a-col>
              <a-col :span="12">
                <p>（32位的API密钥 -- v3）</p>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="v3_serial_number" label="证书序列号" name="v3_serial_number">
            <a-row :gutter="16">
              <a-col :span="20">
                <a-textarea auto-size v-model:value='form.v3_serial_number' placeholder='请输入证书序列号'  />
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item ref="v3_ssl_key" label="ssl_key" name="v3_ssl_key">
            <a-row :gutter="16">
              <a-col :span="20">
                <a-textarea auto-size  v-model:value='form.v3_ssl_key' placeholder='请输入ssl_key'  />
              </a-col>
            </a-row>
          </a-form-item>
        </div>
        <a-form-item ref="status" label="是否启用" name="status">
          <a-radio-group v-model:value="form.status">
            <a-radio :value="1">开启</a-radio>
            <a-radio :value="0">关闭</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }" class='m-t-90'>
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>

<script>
  import { ref, onMounted, reactive, toRefs,inject } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { editPayConfig, getPayConfig } from '@/api/system';
  let defForm = {
    id: '',
    status:0,
    appid: '',
    app_secret: '',
    mchid: '',
    key: '',
    ssl_key:"",
    ssl_cert:"",
    v3_appid: '',
    v3_app_secret: '',
    v3_mchid: '',
    v3_key: '',
    v3_ssl_key:"",
    v3_serial_number:"",
  };
  export default {
    setup() {
      const form = ref({ ...defForm });
      const state = reactive({
        is_have_v3:0,
        labelCol: { span: 3 },
        wrapperCol: { span: 16 },
      });
      const $route = inject('$route')
      const $router = inject('$router')
      const _lodash = inject("_lodash");
      // 获取配置
      const getConfig = async() =>{
        const hide = message.loading('正在加载中...', 0);
        let res = await getPayConfig({id:$route.query.id}).then(res => res.data).catch(error=>error) ;
        setTimeout(hide);
        if (iscode(res)) {
          var config_v2 = {};
          var config_v3 = {};
          config_v2 = _lodash.assign(form.value,res.data.config);
          if(res.data.config_v3){
            config_v3 = _lodash.mapKeys(res.data.config_v3, function(value, key) {
              return "v3_" + key
            });
          }
          form.value = _lodash.assign(config_v2,config_v3);
          form.value.status = res.data.status;
          form.value.pay_type = 1;
          state.is_have_v3 = res.data.is_have_v3;
        } else {
          message.error(res.msg);
        }
      }
      const ruleForm = ref();
      //提交
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          const hide = message.loading('正在加载中...', 0);
          let res = await editPayConfig({...form.value,id:$route.query.id}).then(res => res.data).catch(error=>error) ;
            setTimeout(hide);
          if (iscode(res)) {
            message.success(res.msg);
            setTimeout(() => {
              $router.go(-1)
            }, 1000);
          } else {
            message.error(res.msg);
          }
        }).catch((error) => {
          console.log("error", error);
        });
      };
      onMounted(() => {
        getConfig();
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
      };
    },
  };
</script>